import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-cart-item',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './cart-item.component.html',
  styleUrl: './cart-item.component.scss'
})
export class CartItemComponent {
  @Input() obj: any;
  @Input() level: number = 0;
  @Input() isSelected: boolean = false;
  
  @Output() selectionChange = new EventEmitter<any>();
  @Output() edit = new EventEmitter<any>();
  @Output() remove = new EventEmitter<any>();

  // Track expanded state for each item
  private expandedItems = new Set<any>();

  // Initially expand all items (optional - you can start with everything collapsed)
  ngOnInit() {
    // if (this.obj?.cliConfig) {
    //   this.expandAllInitially(this.obj.cliConfig);
    // }
  }

  toggleExpanded(item: any) {
    if (this.expandedItems.has(item)) {
      this.expandedItems.delete(item);
    } else {
      this.expandedItems.add(item);
    }
  }

  isExpanded(item: any): boolean {
    return this.expandedItems.has(item);
  }

  // Optional: Expand all items initially
  private expandAllInitially(config: any[]) {
    config.forEach(item => {
      if (item.children && item.children.length > 0) {
        this.expandedItems.add(item);
        this.expandAllInitially(item.children);
      }
    });
  }

  // Utility methods for expand/collapse all
  expandAll() {
    if (this.obj?.cliConfig) {
      this.expandAllRecursively(this.obj.cliConfig);
    }
  }

  collapseAll() {
    this.expandedItems.clear();
  }

  private expandAllRecursively(config: any[]) {
    config.forEach(item => {
      if (item.children && item.children.length > 0) {
        this.expandedItems.add(item);
        this.expandAllRecursively(item.children);
      }
    });
  }

  trackByFn(index: number, item: any) {
    return item.value + item.type + item.parent; // Unique identifier for tracking
  }

  // ... your existing methods
}
